import { memo, useState, useRef } from 'react';
import { RightIcon } from '@wisdesign/lsicon';
import PriceDiscountDialog from '../price-discount-dialog';
import { trackEvent, maskData } from '@/utils/mixpanel';
import { useAtomValue } from 'jotai';
import { currentAgentAtom } from '@/stores/agent';

interface PriceDiscountNoticeProps {
  fold?: boolean;
}

const PriceDiscountNotice = memo(({ fold = false }: PriceDiscountNoticeProps) => {
  const [open, setOpen] = useState(false);
  const currentAgent = useAtomValue(currentAgentAtom);
  const openTimeRef = useRef<number>(0);

  const handleClick = () => {
    if (currentAgent) {
      trackEvent('fixed_notice_click', {
        entId: currentAgent.entId,
        name: maskData(currentAgent.name, 'name'),
        id: currentAgent.id,
      });
    }
    openTimeRef.current = Date.now();
    setOpen(true);
  };

  const handleCloseDialog = (isOpen: boolean) => {
    if (!isOpen && openTimeRef.current > 0) {
      const closeTime = Date.now();
      const readDuration = Number(((closeTime - openTimeRef.current) / 1000).toFixed(2));

      if (currentAgent) {
        trackEvent('fixed_notice_close', {
          entId: currentAgent.entId,
          name: maskData(currentAgent.name, 'name'),
          id: currentAgent.id,
          readDuration,
        });
      }

      openTimeRef.current = 0;
    }
    setOpen(isOpen);
  };

  if (fold) {
    // 折叠状态
    return (
      <>
        <div
          className="rounded bg-base w-[55px] cursor-pointer hover:shadow-md"
          onClick={handleClick}
        >
          <div className="bg-[linear-gradient(135deg,#FF6B9D_0%,#FFA06B_100%)] rounded p-xs flex flex-col items-center">
            <span className="text-invert text-lg">🎉</span>
            <span className="text-invert text-xs mt-sm">模型调价</span>
          </div>
        </div>
        <PriceDiscountDialog open={open} onOpenChange={handleCloseDialog} />
      </>
    );
  }

  // 展开状态
  return (
    <>
      <div className="rounded bg-base cursor-pointer hover:shadow-md" onClick={handleClick}>
        <div className="bg-[linear-gradient(135deg,#FF6B9D_0%,#FFA06B_100%)] rounded px-lg py-md flex items-center justify-between">
          <div className="flex items-center gap-md">
            <span className="text-invert text-lg">🎉</span>
            <span className="text-invert text-sm font-medium">模型调价通知</span>
          </div>
          <RightIcon className="text-invert w-[16px] h-[16px]" />
        </div>
      </div>
      <PriceDiscountDialog open={open} onOpenChange={handleCloseDialog} />
    </>
  );
});

PriceDiscountNotice.displayName = 'PriceDiscountNotice';

export default PriceDiscountNotice;
